import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-white pt-16 pb-8 border-t border-white/10" data-id="element-9">
      <div className="container px-4 md:px-6 mx-auto" data-id="element-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-11">
          {/* Brand Info */}
          <div data-id="element-12">
            <div className="flex items-center gap-2 mb-6" data-id="element-13">
              <span className="text-2xl font-bold text-white" data-id="element-14">EZAZ</span>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-15">
              Professional window cleaning services for Phoenix and the East
              Valley. We bring the sunshine back into your home.
            </p>
            <div className="flex gap-4" data-id="element-16">
              <a href="#" className="h-10 w-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-gold hover:text-navy transition-colors" data-id="element-17">
                <Facebook className="h-5 w-5" data-id="element-18" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-gold hover:text-navy transition-colors" data-id="element-19">
                <Instagram className="h-5 w-5" data-id="element-20" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-21">
            <h3 className="text-lg font-bold mb-6 text-gold" data-id="element-22">Quick Links</h3>
            <ul className="space-y-3" data-id="element-23">
              <li data-id="element-24">
                <a href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-25">
                  Home
                </a>
              </li>
              <li data-id="element-26">
                <a href="#services" className="text-gray-300 hover:text-white transition-colors" data-id="element-27">
                  Services
                </a>
              </li>
              <li data-id="element-28">
                <a href="#why-us" className="text-gray-300 hover:text-white transition-colors" data-id="element-29">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-30">
                <a href="#reviews" className="text-gray-300 hover:text-white transition-colors" data-id="element-31">
                  Reviews
                </a>
              </li>
              <li data-id="element-32">
                <a href="#contact" className="text-gray-300 hover:text-white transition-colors" data-id="element-33">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-34">
            <h3 className="text-lg font-bold mb-6 text-gold" data-id="element-35">Our Services</h3>
            <ul className="space-y-3" data-id="element-36">
              <li className="text-gray-300" data-id="element-37">Residential Window Cleaning</li>
              <li className="text-gray-300" data-id="element-38">Commercial Window Cleaning</li>
              <li className="text-gray-300" data-id="element-39">Screen Cleaning</li>
              <li className="text-gray-300" data-id="element-40">Hard Water Removal</li>
              <li className="text-gray-300" data-id="element-41">Solar Panel Cleaning</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-42">
            <h3 className="text-lg font-bold mb-6 text-gold" data-id="element-43">Contact Us</h3>
            <ul className="space-y-4" data-id="element-44">
              <li className="flex items-start gap-3" data-id="element-45">
                <Phone className="h-5 w-5 text-gold mt-1 flex-shrink-0" data-id="element-46" />
                <a href="tel:4805550123" className="text-gray-300 hover:text-white transition-colors" data-id="element-47">
                  (480) 555-0123
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-48">
                <Mail className="h-5 w-5 text-gold mt-1 flex-shrink-0" data-id="element-49" />
                <a href="mailto:info@ezazcleaning.com" className="text-gray-300 hover:text-white transition-colors" data-id="element-50">
                  info@ezazcleaning.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-51">
                <MapPin className="h-5 w-5 text-gold mt-1 flex-shrink-0" data-id="element-52" />
                <span className="text-gray-300" data-id="element-53">
                  Serving Phoenix, Gilbert, Mesa & East Valley
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-gray-400 text-sm" data-id="element-54">
          <p data-id="element-55">
            &copy; {new Date().getFullYear()} EZAZ Window Cleaning. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}